



















































import Vue, { PropType } from 'vue';
import FileUploadMixin from '@/components/mixins/FileUploadMixin.vue';

export interface FormDataInterface {
  title?: string;
  content?: string;
}

export default Vue.extend({
  mixins: [FileUploadMixin],
  props: {
    section: {
      // FIXME update generated format
      // type: Object as () => CvSectionText,
      type: Object as PropType<any>,
      required: true,
    },
    isDeletable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const { title, content } = this.section;
    return {
      // FIXME API would raise an error if `content` is null.
      formData: {
        title: title || '',
        content: content || '',
      } as FormDataInterface,
    };
  },
  methods: {
    onSubmit() {
      this.$emit('submit', this.formData);
    },
    onCancel() {
      this.$emit('cancel');
    },
    onDelete() {
      this.$emit('delete');
    },
  },
});
